import React from "react";
import { Spinner } from "reactstrap";

export const Preloader = () => {
    return <div className="preloader">
        <Spinner className="spinner" color="primary" />
    </div>
}